import { render, staticRenderFns } from "./SubCompViewPackage.vue?vue&type=template&id=d5e0971a&"
import script from "./SubCompViewPackage.vue?vue&type=script&lang=js&"
export * from "./SubCompViewPackage.vue?vue&type=script&lang=js&"
import style0 from "./SubCompViewPackage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports